export default __webpack_public_path__ + "static/media/fasting_right_window@2x.82a5d5a4.jpg";